module.exports = __webpack_public_path__ + "static/public_calendars_2-a77db1eca49d1663306121b54624f654.png";